package app.bloomey.web.components.layouts

import androidx.compose.runtime.*
import app.bloomey.web.components.modals.ModalHost
import app.bloomey.web.components.modals.OffCanvasHost
import app.bloomey.web.components.sections.*
import app.bloomey.web.components.widgets.EnvironmentTag
import app.bloomey.web.components.widgets.IconButton
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.icons.HamburgerIcon
import com.varabyte.kobweb.silk.components.layout.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.components.layout.breakpoint.displayUntil
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import org.jetbrains.compose.web.css.*

@Composable
fun AdminPageLayout(pageTitle: String, pageContent: @Composable ColumnScope.() -> Unit) {
    LaunchedEffect(pageTitle) {
        document.title = "Bloomey - $pageTitle"
    }
    var menuState by remember { mutableStateOf(SideMenuState.CLOSED) }
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    val gutterWidth = 1.cssRem
    AuthGuard {
        Row(modifier = Modifier.fillMaxSize()) {
            AdminSideBar(
                modifier = Modifier.width(300.px)
                    .displayIfAtLeast(Breakpoint.MD)
            )
            if (menuState != SideMenuState.CLOSED) {
                FloatingSideBar(
                    Modifier.zIndex(3),
                    MenuSlideDirection.LeftRight,
                    menuState,
                    close = { menuState = menuState.close() },
                    onAnimationEnd = { if (menuState == SideMenuState.CLOSING) menuState = SideMenuState.CLOSED }
                ){
                    AdminSideBar(it.width(clamp(300.px, 300.px, 40.percent)))
                }
            }
            Column(
                modifier = Modifier
                    .weight(1f)
                    .minHeight(100.vh)
                    .maxHeight(100.vh)
                    .fillMaxWidth()
                    .overflow(Overflow.Auto)
                    .display(DisplayStyle.FlowRoot)
            ) {
                PageToolbar(
                    modifier = Modifier
                        .zIndex(3)
                        .padding(leftRight = gutterWidth, topBottom = 20.px)
                        .thenIf(
                            breakpoint < Breakpoint.MD,
                            Modifier.position(Position.Sticky)
                                .top(0.px)
                                .background(sitePalette.background)
                        ),
                    title = pageTitle
                ) {
                    IconButton(
                        modifier = Modifier.displayUntil(Breakpoint.MD).margin(right = 16.px),
                        onClick = {
                            menuState = SideMenuState.OPEN
                        }) {
                        HamburgerIcon()
                    }
                }
                Column(
                    modifier = Modifier
                        .display(DisplayStyle.Flex)
                        .padding(leftRight = gutterWidth)
                ) {
                    pageContent()
                }
            }
        }
    }
    EnvironmentTag()



    OffCanvasHost()
    ModalHost()
}